import DOMPurify from "dompurify";
import { marked } from "marked";

export default function IssueTitle({ issueKey, issue }) {
  return (
    <div className="diagnostic-title min-w-0">
      <h4
        className="font-semibold text-foreground"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(marked.parse(issue.title || issueKey)),
        }}
      />
    </div>
  );
}
